<template>
  <div class="banner">
    <a href="#">
      <aside class="aside" :style=" 'background-image:url(images/banners/' + backgroundImage + ' ) '">

      </aside>
    </a>
  </div>
</template>
<script type="text/javascript">
  export default {
    name:'Banner',
    props: ['backgroundImage']
  }
</script>
